import React, { useState } from "react";
import "../../../../src/main.css";
import { Placeholder } from "react-bootstrap";
import secureLocalStorage from "react-secure-storage";

function EngagementSchedule({ modifiedData, isLoading, error }) {
  const groupedData = {};
  const [user, setUser] = useState(false);

  modifiedData?.forEach((row) => {
    if (!groupedData[row.hairCoach]) {
      groupedData[row.hairCoach] = [];
    }
    groupedData[row.hairCoach].push(row);
  });

  const handleCheckbox = (e) => {
    setUser(e.target.checked);
  };

  return (
    <div style={{ height: "70vh" }}>
      <div className="form-check">
        <input
          className="form-check-input"
          type="checkbox"
          defaultValue=""
          id="flexCheckChecked"
          defaultChecked=""
          onChange={handleCheckbox}
        />
        <label className="form-check-label" htmlFor="flexCheckChecked">
          <strong>Click checkbox to filter by </strong>{" "}
          <span className="fw-bold ">{secureLocalStorage.getItem("first_name")}</span>
        </label>
      </div>
      <div className="border border-rounded mt-5 scrollable-table-engagement">
        <table className="table table-responsive table-striped table-bordered table-hover">
          <thead className="bg-primary text-white text-white">
            <tr>
              <th className="align-top text-center bg-primary text-white column-width-ten sticky-header-top">
                Hair Coach
              </th>
              <th className="align-top text-center bg-primary text-white column-width-ten sticky-header-top">
                Type
              </th>
              <th className="align-top text-center bg-primary text-white column-width-ten sticky-header-top">
                Prescription call
              </th>
              <th className="align-top text-center bg-primary text-white column-width-ten sticky-header-top">
                Week 1
              </th>
              <th className="align-top text-center bg-primary text-white column-width-ten sticky-header-top">
                Week 3
              </th>
              <th className="align-top text-center bg-primary text-white column-width-ten sticky-header-top">
                Retention and others
              </th>
              <th className="align-top text-center bg-primary text-white column-width-ten sticky-header-top">
                Slot bookings
              </th>
              <th className="align-top text-center bg-primary text-white column-width-ten sticky-header-top">
                Total
              </th>
            </tr>
          </thead>

          <tbody>
            {isLoading
              ? Array.from({ length: 3 }).map((_, index) => (
                  <tr key={index}>
                    {Array.from({ length: 8 }).map((_, index) => (
                      <td kay={index}>
                        <Placeholder as="p" animation="glow">
                          <Placeholder xs={12} />
                        </Placeholder>
                      </td>
                    ))}
                  </tr>
                ))
              : Object.entries(groupedData)?.map(([hairCoach, data]) => (
                  <React.Fragment key={hairCoach}>
                    {data?.map((row, index) => (
                      <React.Fragment key={index}>
                        {user &&
                        row.hairCoach === secureLocalStorage.getItem("first_name") ? (
                          <tr>
                            {index === 0 && (
                              <td className="flex-1" rowSpan={data.length}>
                                {row.hairCoach}
                              </td>
                            )}
                            <td className="flex-1">{row.type}</td>
                            <td className="flex-1 column-width-ten">
                              {row.prescriptionCall}
                            </td>
                            <td className="flex-1 column-width-ten">
                              {row.week1}
                            </td>
                            <td className="flex-1 column-width-ten">
                              {row.week3}
                            </td>
                            <td className="flex-1 column-width-ten">
                              {row.retentionAndOthers}
                            </td>
                            <td className="flex-1 column-width-ten">
                              {row.slotBookings}
                            </td>
                            <td className="flex-1 column-width-ten">
                              {row.total}
                            </td>
                          </tr>
                        ) : !user ? (
                          <tr>
                            {index === 0 && (
                              <td className="flex-1" rowSpan={data.length}>
                                {row.hairCoach}
                              </td>
                            )}
                            <td className="flex-1">{row.type}</td>
                            <td className="flex-1 column-width-ten">
                              {row.prescriptionCall}
                            </td>
                            <td className="flex-1 column-width-ten">
                              {row.week1}
                            </td>
                            <td className="flex-1 column-width-ten">
                              {row.week3}
                            </td>
                            <td className="flex-1 column-width-ten">
                              {row.retentionAndOthers}
                            </td>
                            <td className="flex-1 column-width-ten">
                              {row.slotBookings}
                            </td>
                            <td className="flex-1 column-width-ten">
                              {row.total}
                            </td>
                          </tr>
                        ) : null}
                      </React.Fragment>
                    ))}
                  </React.Fragment>
                ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default EngagementSchedule;
